import React from "react";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { Card, Label, ValueRow, Value, ACCENTS } from "./styles";

const dangerColor = "#ef4444";

const PickColor = (val, accentHex) => {
  if (val >= 90) return dangerColor;
  return accentHex;
};

const CircularPrograssbar = ({ metrics, value, accent = "zinc" }) => {
  const accentHex = ACCENTS[accent] ?? ACCENTS.zinc;

  return (
    <Card $accent={accent}>
      <CircularProgressbarWithChildren
        value={value}
        strokeWidth={12}
        styles={buildStyles({
          pathColor: PickColor(value, accentHex),
          trailColor: "#f1f5f9",
          pathTransitionDuration: 0.4,
        })}
      >
        <ValueRow title={`${metrics}: ${value.toFixed(1)}%`}>
          <Value>{value.toFixed(1)}%</Value>
        </ValueRow>
        <Label>{metrics}</Label>
      </CircularProgressbarWithChildren>
    </Card>
  );
};

export default CircularPrograssbar;
